import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    // backgroundColor: "#F6F7F9",
  },
  headerContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  content: {
    paddingTop: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  securityTab: {
    marginBottom: theme.spacing(4),
  },
  dialogContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  formControl: {
    margin: theme.spacing(1),
  },
}), { index: 999 });

export default useStyles;
